var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Pay UNIT",
        visible: _vm.isOpen,
        width: "7.2rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c("div", { staticClass: "warn-text" }, [
        _c("i", { staticClass: "el-icon-warning" }),
        _vm._v("You should pay at least 1 UNIT to propose successfully"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-item spaceLeft" }, [
        _c("span", { staticClass: "detail-item-label" }, [_vm._v("UNIT :")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "balance-box" },
          [
            _c(
              "el-input",
              {
                attrs: { type: "number" },
                model: {
                  value: _vm.inputVal,
                  callback: function ($$v) {
                    _vm.inputVal = $$v
                  },
                  expression: "inputVal",
                },
              },
              [
                _c("template", { slot: "append" }, [
                  _c(
                    "span",
                    { staticClass: "unit" },
                    [
                      _vm._v("Balance : "),
                      _c("big-number", { attrs: { number: _vm.balance } }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "text-1" }, [
          _vm._v(
            "\n      Your UNIT payment will be counted in your vote directly.\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-2" }, [
        _vm._v("\n    Proposals may pass when they receive more than\n    "),
        _c(
          "span",
          { staticStyle: { "font-size": "0.28rem", color: "#1F1F1F" } },
          [_c("big-number", { attrs: { number: _vm.threshold } })],
          1
        ),
        _vm._v("\n    UNITs of votes.\n  "),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c("loading-btn", {
            staticClass: "common-btn-blue-sm",
            attrs: { label: "Submit" },
            on: { clickHandle: _vm.save },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }